import { render, staticRenderFns } from "./LessonMsgAddLayer.vue?vue&type=template&id=23aa40f2&scoped=true&"
import script from "./LessonMsgAddLayer.vue?vue&type=script&lang=js&"
export * from "./LessonMsgAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./LessonMsgAddLayer.vue?vue&type=style&index=0&id=23aa40f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa40f2",
  null
  
)

export default component.exports